<template>
  <q-form ref="formAttendaceClock">
    <section class="form-section">
      <div class="col-12 row title-page">Informações finais</div>

      <div class="col-12 row q-mt-sm">
        <label>Insira os horários de início e conclusão do atendimento.</label>
      </div>
      <div class="col-12 q-mt-lg">
        <label for="start">Início</label>
        <q-input
          id="start"
          v-model="contract.initialTime"
          bg-color="white"
          class="col-12 q-mt-sm"
          color="red-9"
          type="time"
          dense
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>
      <div class="col-12 q-mt-lg">
        <label for="conclusion_time">Conclusão</label>
        <q-input
          id="conclusion_time"
          v-model="contract.conclusionTime"
          bg-color="white"
          class="col-12 q-mt-sm"
          color="red-9"
          type="time"
          dense
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>
    </section>
  </q-form>
</template>

<script>
import { ref } from "vue";

export default {
  name: "AttendanceClock",
  props: {
    contract: Object,
  },
  setup() {
    let formAttendaceClock = ref(null);

    async function validateForm() {
      return await formAttendaceClock.value.validate();
    }

    return {
      formAttendaceClock,

      validateForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.title-page {
  font-size: 1rem;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
  margin: 0;
}
label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
